import React from 'react'

const WorkerRefundPolicy = () => {
    return (
        <div>WorkerRefundPolicy</div>
    )
}

export default WorkerRefundPolicy